import { IAskAiPromptsEntry, IAskAiPromptsVersion } from '@/creditflowresearch/domain/vo/AskAiPrompts';

export const isSavedVersion = (entry: IAskAiPromptsEntry): entry is IAskAiPromptsVersion => {
  return !entry.isDefault && entry.id !== null && entry.createdAt !== null && entry.updatedAt !== null;
};
